import React from "react";
import { useRef } from "react";
import Card from "react-bootstrap/Card";
import { Button } from "react-bootstrap";
import "./Hsection2cs.css";
import LoadingImage from "./Loadingimage";
import { useNavigate } from "react-router-dom";
import AnimationMasuk from "../animation";
const CardSection = () => {
  const navigate = useNavigate();
  const card_ref = useRef(null);
  const isVisCard = AnimationMasuk(card_ref);
  const cards1 = [
    {
      name:
        localStorage.getItem("bahasa") === "ing"
          ? "Consultation Automotive"
          : "Konsultasi Otomotif",
      image: "https://i.ibb.co.com/XZbGFFT/detailing-image.webp",
      routes: "/consultation-info",
    },
    {
      name:
        localStorage.getItem("bahasa") === "ing"
          ? "Detailing & Coating"
          : "Detailing & Coating",
      image: "https://i.ibb.co.com/d2cMvFZ/coating-image.webp",
      routes: "/detailing&coating-info",
    },
    {
      name:
        localStorage.getItem("bahasa") === "ing"
          ? "Paint Repair"
          : "Reparasi Cat",
      image: "https://i.ibb.co.com/Sm4kfP8/coming-soon.webp",
      routes: "/paint-repair",
    },
    {
      name:
        localStorage.getItem("bahasa") === "ing"
          ? `Paintless Dent Removal`
          : `Ketok PDR`,
      image: "https://i.ibb.co.com/Sm4kfP8/coming-soon.webp",
      routes: "/pdr",
    },
    {
      name:
        localStorage.getItem("bahasa") === "ing"
          ? `Routine maintenance`
          : `Perawatan Rutin`,
      image: "https://i.ibb.co.com/Sm4kfP8/coming-soon.webp",
      routes: "/routine-maintenance",
    },
    {
      name:
        localStorage.getItem("bahasa") === "ing"
          ? `Biro Jasa`
          : `Biro Jasa`,
      image: "https://i.ibb.co.com/Sm4kfP8/coming-soon.webp",
      routes: "/biro-jasa",
    },
    {
      name:
        localStorage.getItem("bahasa") === "ing"
          ? `Buy and sell Used Car`
          : `Jual Beli Mobil Bekas`,
      image: "https://i.ibb.co.com/Sm4kfP8/coming-soon.webp",
      routes: "/used-car",
    },
  ];
  const handleCardClick = (link) => {
    navigate(link);
    console.log("Clicked! Link:", link);
  };
  return (
    <>
      <div className="section-card ">
        <h2 className="service-text roleway">
          {localStorage.getItem("bahasa") === "ing"
            ? "Our Specialization"
            : "Spesialisasi Kami"}
        </h2>
        <div
          className={
            isVisCard
              ? "card-container fade-in-bottom"
              : "card-container hidden"
          }
          ref={card_ref}
        >
          {cards1.map((item, index) => {
            return (
              <Card
                className="bg-dark text-white card-1"
                style={{
                  position: "relative",
                  overflow: "hidden",
                }}
                key={index}
                onClick={() => handleCardClick(item.routes)}
              >
                <LoadingImage
                  src={item.image}
                  alt="Card image"
                  className="card-img"
                />
                <Card.ImgOverlay
                  style={{
                    display: "flex",
                    justifyContent: "end",
                    alignItems: "start",
                    flexDirection: "column",
                  }}
                >
                  <Button
                    variant="none"
                    className="btn-card roleway"
                    style={{ display: "flex", flexDirection: "row", alignItems: "center" }}
                    href={item.routes}
                  >
                    <span>
                      <b>
                        <i className="bi bi-chevron-double-right icon-btn"></i>
                      </b>
                    </span>
                    <span
                      className="text-btn roleway"
                      style={{ fontSize: "24px", whiteSpace: "normal", textAlign: "left", lineHeight: "1.2", marginLeft: "10px" }}
                    >
                      {item.name}
                    </span>
                  </Button>
                </Card.ImgOverlay>
              </Card>
            );
          })}
        </div>
      </div>
    </>
  );
};
export default CardSection;
